const loadingStates = new WeakMap();

export function stopSelectLoading(select) {
  loadingStates.get(select)?.finish();
}

export function startSelectLoading(select, { lock = false } = {}) {
  if (!select) return () => {};
  let state = loadingStates.get(select);
  if (!state) {
    const indicator = select.ownerDocument.createElement("span");
    indicator.className = "d-flex align-items-center gap-2 mt-1 small text-body-secondary";
    indicator.dataset.selectLoading = select.id || select.name || "";
    indicator.setAttribute("role", "status");
    indicator.innerHTML = '<span class="spinner-border spinner-border-sm" aria-hidden="true"></span><span>Ładowanie wyników…</span>';
    const control = select.tomselect?.wrapper || select;
    control.after(indicator);
    state = { indicator, control, locked: false };
    state.onDestroy = () => stopSelectLoading(select);
    select.tomselect?.on("destroy", state.onDestroy);
    loadingStates.set(select, state);
  }

  const token = {};
  state.token = token;
  select.setAttribute("aria-busy", "true");
  state.control.setAttribute("aria-busy", "true");
  if (lock && select.tomselect && !state.locked) {
    state.wasLocked = select.tomselect.isLocked;
    state.locked = true;
    const query = select.tomselect.inputValue();
    select.tomselect.close(false);
    select.tomselect.setTextboxValue(query);
    select.tomselect.lock();
  }

  const finish = () => {
    if (loadingStates.get(select) !== state || state.token !== token) return;
    state.indicator.remove();
    select.removeAttribute("aria-busy");
    state.control.removeAttribute("aria-busy");
    if (state.locked && !state.wasLocked) select.tomselect?.setLocked();
    select.tomselect?.off("destroy", state.onDestroy);
    loadingStates.delete(select);
  };
  state.finish = finish;
  return finish;
}
